module.exports = __webpack_public_path__ + "static/media/roadSidePrimary.89b2b148.svg";